(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["singleldp-affiliate-livertox-BlockHeader"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let menuIcon = document.getElementById('menu-icon');
  let mainMenu = document.querySelector('.main-menu');
  let menuItems = document.querySelectorAll('.main-menu .nav-item');

  menuIcon.addEventListener('click', function () {
    toggleMenu();
  });

  menuItems.forEach(function (item) {
    item.addEventListener('click', function () {
      if (isSmallScreen()) {
        toggleMenu();
      }
     

      let targetId = this.getAttribute('data-scroll-to');

      if (targetId) {
        scrollToTarget(targetId);
      }
    
    });
  });

  document.addEventListener('click', function (event) {
    let isClickInsideMenu = mainMenu.contains(event.target);
    let isClickOnMenuIcon = menuIcon.contains(event.target);

    if (!isClickInsideMenu && !isClickOnMenuIcon && isSmallScreen()) {
      closeMenu();
    }
  });

  function toggleMenu() {
    mainMenu.style.display = (mainMenu.style.display === 'block') ? 'none' : 'block';
  }

  function closeMenu() {
    mainMenu.style.display = 'none';
  }

  function isSmallScreen() {
    return window.innerWidth <= 1199;
  }
 function scrollToTarget(targetId) {
    let targetElement = document.getElementById(targetId);

    if (targetElement) {
      const elementRect = targetElement.getBoundingClientRect();
      const offsetTop = elementRect.top + window.scrollY;

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth' 
      });
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["singleldp-affiliate-thankyou-Block01"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {

    var urlParams = new URLSearchParams(window.location.search);

   
    urlParams.forEach(function(value, key) {
    
        var element = document.querySelector("." + key);
        if (element) {
            element.textContent =value;
        }
    });
});

    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["singleldp-nubest-white-BlockHeader"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const menuIcon = document.getElementById('menu-icon');
  const mainMenu = document.querySelector('.main-menu');
  const menuItems = document.querySelectorAll('.main-menu li');

  menuIcon.addEventListener('click', function () {
    toggleMenu();
  });

  menuItems.forEach(function (item) {
    item.addEventListener('click', function () {
      if (isSmallScreen()) {
        toggleMenu();
      }
    });
  });

  document.addEventListener('click', function (event) {
    const isClickInsideMenu = mainMenu.contains(event.target);
    const isClickOnMenuIcon = menuIcon.contains(event.target);

    if (!isClickInsideMenu && !isClickOnMenuIcon && isSmallScreen()) {
      closeMenu();
    }
  });

  function toggleMenu() {
    mainMenu.style.display = (mainMenu.style.display === 'block') ? 'none' : 'block';
  }

  function closeMenu() {
    mainMenu.style.display = 'none';
  }

  function isSmallScreen() {
    return window.innerWidth <= 1199;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
